// extracted by mini-css-extract-plugin
module.exports = {"text":"text__PqNvp","label":"label__3eLdr","button":"button__2BMV_","box-wrapper":"box-wrapper__2v8YY","box":"box__-iBNU","foot-note":"foot-note__2EmfB"};